import { render, staticRenderFns } from "./webadmin-errorlog.vue?vue&type=template&id=f8980c96&scoped=true&"
import script from "./webadmin-errorlog.vue?vue&type=script&lang=js&"
export * from "./webadmin-errorlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8980c96",
  null
  
)

export default component.exports